module.exports = __webpack_public_path__ + "img/course71.688e0043.png";